:global(.searchModalPortal) {
  display: none;
}

@media all and (width > 1076px) {
  :global(.searchModalPortal) {
    display: block;
  }
}

.searchFieldForm {
  flex: 1;
}

.searchFieldForm svg > path {
  fill: var(--colors-text-main);
}

.searchFieldForm input:placeholder-shown {
  text-overflow: ellipsis;
}
